/* Broadcast 8.0.0. Uses the original drawer, menu links and scroll-lock events. */
(function () {
  'use strict';
  if (window.broadcastPhoneMenu) return;
  var media = window.matchMedia('(max-width: 749px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var controllers = new Map();
  var nextId = 0;

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function settle(node) {
    return new Promise(function (resolve) {
      var timer;
      function finish(event) {
        if (event && (event.target !== node || event.propertyName !== 'transform')) return;
        clearTimeout(timer);
        node.removeEventListener('transitionend', finish);
        resolve();
      }
      node.addEventListener('transitionend', finish);
      timer = setTimeout(finish, reduced.matches ? 30 : 470);
    });
  }

  function focus(node) {
    if (node && node.isConnected) node.focus({ preventScroll: true });
  }

  function validURL(url) {
    return url && url !== '#' && !/^\s*(javascript|data):/i.test(url);
  }


  // Decorate the four utility links without replacing their URLs or click handlers.
  function decorateUtilities(root, decorated) {
    var shapes = {
      about: ['M12 11v6', 'M12 7h.01', 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0'],
      login: ['M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0', 'M4 21v-2a8 8 0 0 1 16 0v2'],
      wishlist: ['M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8'],
      reviews: ['m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-2.9-5.6 2.9 1.1-6.2L3 9.6l6.2-.9Z']
    };
    var aliases = {about: 'about', 'about us': 'about', login: 'login', 'log in': 'login', 'sign in': 'login', wishlist: 'wishlist', 'wish list': 'wishlist', reviews: 'reviews', review: 'reviews', reviewsz: 'reviews'};
    decorated = (decorated || []).filter(function (item) { return root.contains(item.link); });
    root.querySelectorAll('.mm-acc-link, .mobile-menu__block--menu-columns a').forEach(function (link) {
      if (link.closest('.mm-acc-panel')) return;
      if (link.classList.contains('qmm-utility-link') && link.querySelector(':scope > .qmm-utility-icon')) return;
      var label = link.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      var kind = aliases[label];
      // Wishlist apps append counts (Wishlist 1, Wishlist(2), Wishlist99+).
      if (!kind && /^wish\s*list(?:\s*[:(\[]?\s*\d+\+?\s*[)\]]?)?$/.test(label)) kind = 'wishlist';
      if (!kind) return;
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'qmm-utility-icon');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '14');
      svg.setAttribute('height', '14');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.5');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      shapes[kind].forEach(function (d) {
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', d);
        svg.appendChild(path);
      });
      link.classList.add('qmm-utility-link');
      link.insertBefore(svg, link.firstChild);
      var saved = decorated.find(function (item) { return item.link === link; });
      if (saved) saved.icon = svg;
      else decorated.push({link: link, icon: svg});
    });
    return decorated;
  }

  function Menu(drawer) {
    this.drawer = drawer;
    this.inner = drawer.querySelector('[data-drawer-inner]');
    this.head = this.inner && this.inner.querySelector('.drawer__head');
    this.close = this.head && this.head.querySelector('[data-drawer-close]');
    if (!this.inner || !this.head || !this.close) return;
    this.utilityLinks = decorateUtilities(this.inner);
    this.stack = [];
    this.savedRoots = [];
    this.features = new WeakMap();
    this.busy = false;
    this.destroyed = false;
    this.rootScroll = 0;
    this.scrollable = this.inner.getAttribute('data-scroll-lock-scrollable');
    this.inner.setAttribute('data-scroll-lock-scrollable', '');
    this.closeLabel = this.close.getAttribute('aria-label');
    if (!this.closeLabel) this.close.setAttribute('aria-label', 'Close menu');
    this.monogram = element('span', 'qmm-monogram');
    var monogramImage = element('img');
    monogramImage.alt = 'HoQ monogram';
    monogramImage.width = 36;
    monogramImage.height = 36;
    monogramImage.decoding = 'async';
    monogramImage.src = 'https://cdn.shopify.com/s/files/1/0599/4125/7295/files/HoQ_-_Monogram.png?v=1768691773';
    this.monogram.appendChild(monogramImage);
    this.head.appendChild(this.monogram);
    this.stage = element('div', 'qmm-stage');
    this.stage.hidden = true;
    this.inner.appendChild(this.stage);
    this.click = this.onClick.bind(this);
    this.keydown = this.onKeydown.bind(this);
    this.keyup = this.onKeyup.bind(this);
    drawer.addEventListener('click', this.click, true);
    drawer.addEventListener('keydown', this.keydown, true);
    drawer.addEventListener('keyup', this.keyup, true);
    this.observer = new MutationObserver(function () {
      if (!drawer.classList.contains('is-open') && !drawer.classList.contains('is-closing')) this.reset();
    }.bind(this));
    this.observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    this.utilityObserver = new MutationObserver(function () {
      if (this.destroyed) return;
      this.utilityObserver.disconnect();
      this.utilityLinks = decorateUtilities(this.inner, this.utilityLinks);
      this.utilityObserver.observe(this.inner, { childList: true, characterData: true, subtree: true });
    }.bind(this));
    this.utilityObserver.observe(this.inner, { childList: true, characterData: true, subtree: true });
    drawer.setAttribute('data-qmm-ready', '');
    this.ready = true;
  }

  Menu.prototype.onClick = function (event) {
    if (!media.matches || !this.drawer.classList.contains('is-open')) return;
    var target = event.target.closest('button, summary, a');
    if (!target) return;
    if (target.matches('.qmm-back')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.back();
      return;
    }
    var source = this.features.get(target);
    if (!source && target.matches('.mm-acc-summary')) source = target.closest('.mm-acc-item');
    if (!source) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!this.busy && !this.drawer.isAnimating) this.open(source, target);
  };

  Menu.prototype.build = function (source) {
    var original = source.querySelector(':scope > .mm-acc-panel > .mm-acc-list');
    if (!original) return null;
    var title = source.dataset.qmmTitle || source.querySelector('summary > span').textContent.trim();
    var panel = element('section', 'qmm-panel');
    panel.setAttribute('data-scroll-lock-scrollable', '');
    var back = element('button', 'qmm-back', 'Back');
    back.type = 'button';
    back.setAttribute('aria-label', 'Back to previous menu');
    var heading = element('h2', 'qmm-title', title);
    heading.id = 'qmm-title-' + (++nextId);
    panel.id = 'qmm-panel-' + nextId;
    panel.setAttribute('aria-labelledby', heading.id);
    panel.append(back, heading);
    var list = original.cloneNode(true);

    // The original snippet uses no IDs. Remove any section-injected IDs on copies.
    list.removeAttribute('id');
    list.querySelectorAll('[id]').forEach(function (node) {
      node.removeAttribute('id');
    });
    list.querySelectorAll('details[open]').forEach(function (node) {
      node.open = false;
    });

    var entries = Array.from(list.children);
    var cardCount = entries.length >= 6 ? 4 : 2;
    list.classList.add('qmm-grid');

    // Keep the existing card slots; entries without an image stay as text rows.
    entries.forEach(function (entry, index) {
      if (index >= cardCount || !(entry.dataset.qmmImage || '').trim()) return;

      var isBranch = entry.matches('.mm-acc-item');
      var link = !isBranch && entry.querySelector('a.mm-acc-link');
      if (!isBranch && !link) return;
      var card = isBranch ? element('button') : link.cloneNode(false);
      card.className = 'qmm-card';

      if (isBranch) {
        card.classList.add('qmm-card--branch');
        card.type = 'button';
        card.setAttribute('aria-expanded', 'false');
        this.features.set(card, entry);
      }

      var imageBox = element('span', 'qmm-card__media');
      imageBox.setAttribute('aria-hidden', 'true');

      if (entry.dataset.qmmImage) {
        var image = element('img');
        image.alt = '';
        image.width = 360;
        image.height = 240;
        image.decoding = 'async';
        image.loading = 'lazy';

        // Keep the empty image box and its clickable card on load failure.
        image.addEventListener('error', function () {
          image.remove();
        }, { once: true });

        image.src = entry.dataset.qmmImage;
        imageBox.appendChild(image);
      }

      var label = entry.dataset.qmmTitle || (isBranch ? entry.querySelector('summary > span').textContent : link.textContent).trim();
      var caption = element('span', 'qmm-card__label');
      caption.appendChild(element('span', 'qmm-card__title', label));

      if (isBranch) {
        var caret = element('span', 'qmm-card__caret');
        caret.setAttribute('aria-hidden', 'true');
        var icon = entry.querySelector(':scope > .mm-acc-summary .mm-acc-caret svg');
        if (icon) caret.appendChild(icon.cloneNode(true));
        caption.appendChild(caret);
      }

      card.append(imageBox, caption);
      var item = element('li', 'qmm-grid__card');
      item.appendChild(card);
      entry.replaceWith(item);
    }.bind(this));

    var url = source.dataset.qmmUrl;
    var hasAll = entries.some(function (entry) {
      return Array.from(entry.querySelectorAll('a.mm-acc-link')).some(function (link) {
        return link.getAttribute('href') === url;
      });
    });

    // Keep the new list valid without changing the existing desktop markup.
    Array.from(list.children).forEach(function (child) {
      if (child.tagName === 'LI') return;
      var item = element('li', 'mm-acc-leaf');
      child.replaceWith(item);
      item.appendChild(child);
    });

    panel.appendChild(list);

    if (validURL(url) && !hasAll) {
      var all = element('a', 'mm-acc-link qmm-view-all', 'View all ' + title);
      all.href = url;
      panel.appendChild(all);
    }

    return panel;
  };

  Menu.prototype.lockRoots = function () {
    var self = this;
    function walk(parent) {
      Array.from(parent.children).forEach(function (node) {
        if (node === self.head || node === self.stage || node.matches('script, style, link')) return;
        if (node.contains(self.head) || node.contains(self.stage)) return walk(node);
        self.savedRoots.push({
          node: node,
          inert: node.inert,
          aria: node.getAttribute('aria-hidden')
        });
        node.inert = true;
        node.setAttribute('aria-hidden', 'true');
      });
    }
    walk(this.inner);
  };

  Menu.prototype.unlockRoots = function () {
    this.savedRoots.forEach(function (item) {
      item.node.inert = item.inert;
      if (item.aria === null) item.node.removeAttribute('aria-hidden');
      else item.node.setAttribute('aria-hidden', item.aria);
    });
    this.savedRoots = [];
  };

  Menu.prototype.open = async function (source, trigger) {
    var panel = this.build(source);
    if (!panel) return;
    this.busy = true;
    focus(this.close);
    var previous = this.stack[this.stack.length - 1];

    if (!previous) {
      this.rootScroll = this.inner.scrollTop;
      this.inner.scrollTop = 0;
      this.drawer.setAttribute('data-qmm-submenu', '');
      this.stage.hidden = false;
      this.lockRoots();
    } else {
      previous.panel.inert = true;
      previous.panel.setAttribute('aria-hidden', 'true');
      previous.panel.classList.remove('is-current');
      previous.panel.classList.add('is-behind');
    }

    if (window.theme && window.theme.a11y) window.theme.a11y.removeTrapFocus();
    source.open = false;

    var frame = {
      panel: panel,
      trigger: trigger,
      expanded: trigger.getAttribute('aria-expanded'),
      controls: trigger.getAttribute('aria-controls')
    };

    trigger.setAttribute('aria-expanded', 'true');
    trigger.setAttribute('aria-controls', panel.id);
    this.stack.push(frame);
    this.stage.appendChild(panel);

    // Commit the starting position before changing it to start the CSS transition.
    panel.getBoundingClientRect();
    panel.classList.add('is-current');
    focus(panel.querySelector('.qmm-back'));
    await settle(panel);
    if (!this.destroyed) this.busy = false;
  };

  Menu.prototype.restoreTrigger = function (frame) {
    ['expanded', 'controls'].forEach(function (key) {
      if (frame[key] === null) frame.trigger.removeAttribute('aria-' + key);
      else frame.trigger.setAttribute('aria-' + key, frame[key]);
    });
  };

  Menu.prototype.back = async function () {
    if (this.busy || !this.stack.length) return;
    this.busy = true;
    focus(this.close);
    var frame = this.stack.pop();
    var previous = this.stack[this.stack.length - 1];

    if (previous) {
      previous.panel.inert = false;
      previous.panel.removeAttribute('aria-hidden');
      previous.panel.classList.remove('is-behind');
      previous.panel.classList.add('is-current');
    }

    frame.panel.inert = true;
    frame.panel.setAttribute('aria-hidden', 'true');
    frame.panel.classList.remove('is-current');
    await settle(frame.panel);
    frame.panel.remove();
    this.restoreTrigger(frame);

    if (this.destroyed) return;

    if (!previous) {
      this.stage.hidden = true;
      this.drawer.removeAttribute('data-qmm-submenu');
      this.unlockRoots();
      this.inner.scrollTop = this.rootScroll;

      if (this.drawer.classList.contains('is-open') && window.theme && window.theme.a11y) {
        window.theme.a11y.trapFocus(this.inner, { elementToFocus: frame.trigger });
        this.inner.scrollTop = this.rootScroll;
      }
    }

    if (this.drawer.classList.contains('is-open')) focus(frame.trigger);
    this.busy = false;
  };

  Menu.prototype.onKeydown = function (event) {
    if (!this.stack.length) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.eatEscapeKeyup = true;
      this.back();
    }

    if (event.key !== 'Tab') return;

    var panel = this.stack[this.stack.length - 1].panel;
    var focusable = [this.close].concat(
      Array.from(panel.querySelectorAll('button, a[href], input, select, textarea, [tabindex]'))
        .filter(function (node) {
          return !node.disabled &&
            node.tabIndex >= 0 &&
            !node.closest('[inert], [hidden], [aria-hidden="true"]') &&
            node.getClientRects().length;
        })
    );

    var index = focusable.indexOf(document.activeElement);

    if (event.shiftKey && index <= 0) {
      event.preventDefault();
      focus(focusable[focusable.length - 1]);
    } else if (!event.shiftKey && (index < 0 || index === focusable.length - 1)) {
      event.preventDefault();
      focus(focusable[0]);
    }
  };

  Menu.prototype.onKeyup = function (event) {
    if (event.key === 'Escape' && this.eatEscapeKeyup) {
      event.stopImmediatePropagation();
      this.eatEscapeKeyup = false;
    }
  };

  Menu.prototype.reset = function () {
    this.stack.forEach(this.restoreTrigger.bind(this));
    this.stack = [];
    this.stage.replaceChildren();
    this.stage.hidden = true;
    this.drawer.removeAttribute('data-qmm-submenu');
    this.unlockRoots();
    this.busy = false;
  };

  Menu.prototype.destroy = function () {
    this.destroyed = true;
    this.observer.disconnect();
    this.utilityObserver.disconnect();
    this.reset();
    this.stage.remove();
    this.monogram.remove();
    this.utilityLinks.forEach(function (item) {
      item.icon.remove();
      item.link.classList.remove('qmm-utility-link');
    });
    this.drawer.removeAttribute('data-qmm-ready');

    if (this.scrollable === null) this.inner.removeAttribute('data-scroll-lock-scrollable');
    else this.inner.setAttribute('data-scroll-lock-scrollable', this.scrollable);

    if (this.closeLabel === null) this.close.removeAttribute('aria-label');
    else this.close.setAttribute('aria-label', this.closeLabel);

    this.drawer.removeEventListener('click', this.click, true);
    this.drawer.removeEventListener('keydown', this.keydown, true);
    this.drawer.removeEventListener('keyup', this.keyup, true);

    // A breakpoint change can cancel the animation that native Broadcast awaits.
    if (this.drawer.isAnimating) {
      this.inner.dispatchEvent(new Event('animationend', { bubbles: true }));
    }

    Promise.resolve().then(function () {
      if (this.drawer.isConnected && this.drawer.classList.contains('is-open')) {
        this.drawer.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: true }));
      }
    }.bind(this));
  };

  function refresh() {
    controllers.forEach(function (controller, drawer) {
      if (!media.matches || !drawer.isConnected) {
        controller.destroy();
        controllers.delete(drawer);
      }
    });

    if (!media.matches) return;

    document.querySelectorAll('header-drawer[data-drawer], header-drawer.drawer--header').forEach(function (drawer) {
      if (controllers.has(drawer) || !drawer.querySelector('.mm-acc-item, .mm-acc-leaf')) return;
      var controller = new Menu(drawer);
      if (controller.ready) controllers.set(drawer, controller);
    });
  }

  window.broadcastPhoneMenu = { refresh: refresh };
  media.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', refresh);

  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (controller, drawer) {
      if (event.target.contains(drawer)) {
        controller.destroy();
        controllers.delete(drawer);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
}());